import React from "react";
import { Button, Label, Modal, ModalBody, ModalFooter } from "reactstrap";

const normalizeModalItems = (list = []) =>
  (Array.isArray(list) ? list : [])
    .map((item) => {
      const id = String(item?.id ?? "").trim();
      const label = String(item?.label ?? item?.name ?? "").trim();
      if (!id) return null;
      return { id, label: label || id };
    })
    .filter(Boolean);

const BulkSelectionReviewModal = ({
  isOpen,
  onClose,
  title = "Selected items",
  listLabel = "Selected items",
  items: itemsProp = [],
  onItemDeselect,
  onDeselectAll,
}) => {
  const items = normalizeModalItems(itemsProp);

  const removeItem = (itemId) => {
    const id = String(itemId ?? "").trim();
    if (!id) return;
    onItemDeselect?.(id);
  };

  const handleDeselectAll = () => {
    if (!items.length) return;
    onDeselectAll?.();
  };

  return (
    <Modal
      isOpen={isOpen}
      toggle={onClose}
      backdrop="static"
      size="lg"
      centered
      className="modal-full-height"
    >
      <ModalBody className="p-4">
        <div className="d-flex justify-content-between align-items-center mb-2">
          <h5 className="fw-bold mb-0">{title}</h5>
          <Button close type="button" onClick={onClose} />
        </div>
        <hr />
        <Label className="mb-2">
          {listLabel} ({items.length})
        </Label>
        {items.length ? (
          <div className="d-flex flex-wrap gap-2 mb-0">
            {items.map((item) => (
              <span
                key={item.id}
                className="badge bg-light text-dark border d-inline-flex align-items-center gap-1 fw-normal py-2 px-2"
                style={{ maxWidth: "100%" }}
              >
                <span className="text-truncate">{item.label}</span>
                <button
                  type="button"
                  className="btn btn-link text-danger p-0 lh-1 flex-shrink-0 border-0"
                  onClick={() => removeItem(item.id)}
                  aria-label={`Remove ${item.label}`}
                >
                  <i className="fa fa-times" aria-hidden="true" />
                </button>
              </span>
            ))}
          </div>
        ) : (
          <p className="text-muted mb-0">No items selected.</p>
        )}
      </ModalBody>
      <ModalFooter className="d-flex justify-content-between w-100">
        <Button
          color="primary"
          type="button"
          disabled={!items.length}
          onClick={handleDeselectAll}
        >
          Deselect all
        </Button>
        <Button color="secondary" type="button" onClick={onClose}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default BulkSelectionReviewModal;
